import axios from "axios";
import { EXTERNAL_API_URL } from "../index";

export const COOPERATIVE_MEMBER_URL = "CooperativeMember";

export function createCooperativeMember(data) {
  return axios.post(EXTERNAL_API_URL + COOPERATIVE_MEMBER_URL, data);
}

export async function listCooperativeMembers(params) {
  const response = await axios.get(EXTERNAL_API_URL + COOPERATIVE_MEMBER_URL, {
    params: {
      Name: params?.name ?? "",
      NIF: params?.nif ?? "",
      DocumentNumber: params?.documentNumber ?? "",
      FunctionId: params?.functionId || undefined,
      StartDate: params?.startDate ?? undefined,
      EndDate: params?.endDate ?? undefined,
      ExpiringIn30Days: params?.expiringIn30Days || undefined,
      ShowInactive: params?.showInactive || undefined,
      FO_User_Collective_Id: params?.foUserCollectiveId ?? undefined,
      PageIndex: params?.pageIndex ?? 1,
      PageSize: params?.pageSize ?? 15,
      SortColumn: params?.sortColumn ?? undefined,
      SortDirection: params?.sortDirection ?? undefined,
    },
  });

  return response.data;
}

export async function getCooperativeMemberDetails(id) {
  const response = await axios.get(`${EXTERNAL_API_URL}${COOPERATIVE_MEMBER_URL}/${id}`);
  return response.data;
}

export async function getCooperativeMemberDocument(memberId, documentKey) {
  const response = await axios.get(`${EXTERNAL_API_URL}${COOPERATIVE_MEMBER_URL}/${memberId}/document`, {
    params: { documentKey },
    responseType: "blob",
  });

  return response.data;
}

export function updateCooperativeMember(data) {
  return axios.put(`${EXTERNAL_API_URL}${COOPERATIVE_MEMBER_URL}`, data);
}

export async function activateCooperativeMember(memberId) {
  const response = await axios.put(EXTERNAL_API_URL + COOPERATIVE_MEMBER_URL + "/activate", {
    MemberId: memberId,
  });
  return response.data;
}

export async function inactivateCooperativeMember(memberId, data) {
  const formData = new FormData();
  formData.append("MemberId", memberId);
  if (data.get("InactivationReason")) {
    formData.append("InactivationReason", data.get("InactivationReason"));
  }
  if (data.get("InactivationDocument")) {
    formData.append("InactivationDocument", data.get("InactivationDocument"));
  }
  const response = await axios.put(EXTERNAL_API_URL + COOPERATIVE_MEMBER_URL + "/inactivate", formData);
  return response.data;
}
